import {FC, useEffect} from 'react'
import RegSearch from "./RegSearch";
import Offers from "../Campaign";
import Content from "../main/Content";
import Loader from "../common/Loader/Loader";
import NavNextPrev from "../common/NavNextPrev/NavNextPrev";


interface Props {
    booking: Booking
    pageContent:ContentPage,
    setBooking: Function,
    content:Content
}

const Car: FC<Props> = ({ pageContent, booking, setBooking, content }) => {
    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    return (
        <div className="input-outer reg-container">
            <div className="row mobile-reverse">
                <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12 col-xxs-12 z-99">
                    <div className="text-content">
                        {!booking.loading ? (
                            <Offers booking={booking} setBooking={setBooking}/>
                        ) : ''}
                    </div>
                </div>
                <div className="main-bg col-lg-8 col-md-8 col-sm-12 col-xs-12 col-xxs-12" style={{'minHeight': '300px'}}>
                    {!booking.loading ? (
                        <>
                            <Content booking={booking} content={pageContent}/>
                        </>
                    ) : <Loader booking={booking}/>}
                    <RegSearch booking={booking} setBooking={setBooking}/>
                    <NavNextPrev booking={booking} setBooking={setBooking} content={content} />
                </div>
            </div>
        </div>
    )
}

export default Car
